import React from "react";
import ItemContainerShared from "shared/itemLists/items/ItemContainer.shared";

import { sortableElement } from "react-sortable-hoc";

const SortableItem = sortableElement((props) => (
  <ItemContainerShared {...props} />
));

export default function DueItems(props) {
  const {
    dueItems,
    setOpenChecklist,
    listType,
    currentTimeInMinutes,
    dueItemCollection,
    children,
    setCursorIndex,
  } = props;
  let keyString = "";
  let hasBreak = false;
  let prevItem = null;
  return (
    <div className="Due-items">
      {dueItems.map((item, i) => {
        keyString = item.id ? item.id : item.day;
        prevItem = dueItems[i - 1];
        hasBreak = prevItem !== undefined;
        return (
          <SortableItem
            key={keyString}
            collection={dueItemCollection}
            index={i}
            inListIndex={i}
            isDue={true}
            details={item}
            currentTimeInMinutes={currentTimeInMinutes}
            hasBreak={hasBreak}
            setOpenChecklist={setOpenChecklist}
            listType={listType}
          />
        );
      })}
      {children}
    </div>
  );
}
